import { Node_Type } from "./../../ricos-schema/legacy/wix/rich_content/v1";
const DEFAULT_COUNTABLE_TYPES = [
  Node_Type.APP_EMBED,
  Node_Type.AUDIO,
  Node_Type.BUTTON,
  Node_Type.CODE_BLOCK,
  Node_Type.DIVIDER,
  Node_Type.EMBED,
  Node_Type.EXTERNAL,
  Node_Type.FILE,
  Node_Type.GALLERY,
  Node_Type.GIF,
  Node_Type.HEADING,
  Node_Type.HTML,
  Node_Type.IMAGE,
  Node_Type.LINK_PREVIEW,
  Node_Type.PARAGRAPH,
  Node_Type.POLL,
  Node_Type.VIDEO
];
const isTextContainer = (type) => [Node_Type.CODE_BLOCK, Node_Type.HEADING, Node_Type.PARAGRAPH].includes(type);
const isNonTextual = (type) => [
  Node_Type.APP_EMBED,
  Node_Type.AUDIO,
  Node_Type.BUTTON,
  Node_Type.DIVIDER,
  Node_Type.EMBED,
  Node_Type.EXTERNAL,
  Node_Type.FILE,
  Node_Type.GALLERY,
  Node_Type.GIF,
  Node_Type.HTML,
  Node_Type.IMAGE,
  Node_Type.LINK_PREVIEW,
  Node_Type.POLL,
  Node_Type.VIDEO
].includes(type);
export {
  DEFAULT_COUNTABLE_TYPES,
  isNonTextual,
  isTextContainer
};
//# sourceMappingURL=types.js.map
